import CustomerOrderPage from "./CustomerOrderPage.vue";

export {CustomerOrderPage}
export default CustomerOrderPage
